export const translations = {
    es: {
        //Navbar
        navbar_home: "INICIO",
        navbar_itinerary: "ITINERARIO",
        navbar_confirm: "CONFIRMA TU ASISTENCIA",
        navbar_gifts: "MESA DE REGALOS",
        // HeroSection
        hero_date: "29 de Agosto de 2026",
        hero_days: "DÍAS",
        hero_hours: "HORAS",
        hero_minutes: "MINUTOS",
        hero_seconds: "SEGUNDOS",
        // Parents
        parents_title: "Acompañados por nuestros padres, nos complace invitarte a nuestra boda",
        parents_gf: "Padres de la novia",
        parents_bf: "Padres del novio",
        // Information
        information_title: "Por favor, considera lo siguiente",
        information_weather_title: "CLIMA",
        information_weather: "Clima actual en la Ciudad de México",
        information_dresscode_title: "CÓDIGO DE VESTIMENTA",
        information_dresscode_type: "Formal",
        information_dresscode_colors: "No colores claros",
        information_dresscode_men: "Hombres:",
        information_dresscode_men2: "Traje con corbata",
        information_dresscode_women: "Mujeres:",
        information_dresscode_women2: "Vestido largo de noche",
        information_nokids_title: "NO NIÑOS",
        information_nokids_text: "Hagamos de esta celebración una cita especial",
        information_nokids_text2: "Agradecemos tu comprensión",
        // Recommendations
        recommendations_title: "Recomendaciones para tu visita",
        card_hotel_title: "HOSPEDAJE",
        card_hotel_header1: "Si nos visitas de fuera de la ciudad...",
        card_hotel_header2: "Tenemos descuento en el Hotel Barceló Reforma",
        btn_view_info: "Ver Información",
        btn_download_pdf: "Descargar PDF",
        card_transport_title: "MOVILIDAD",
        card_transport_header1: "El salón cuenta con Valet Parking",
        card_transport_header2: "Recomendamos el uso de taxi o uber para mayor comodidad",
        pdf_fallback: "Tu navegador no soporta PDFs.",
        pdf_download_link: "Descárgalo aquí",
        // PhotoGallery
        photogallery_title: "Nuestros Momentos",
        photogallery_book: "Libro de firmas",
        photogallery_name: "Tu nombre...",
        photogallery_message: "Algun recuerdo o mensaje que quieras dedicarnos...",
        photogallery_send: "Enviar Mensaje",
        // Footer
        footer_text: "Gracias por acompañarnos en este momento tan especial",

        // Itinerary
        itinerary_title: "Itinerario",
        itinerary_church_title: "CEREMONIA",
        itinerary_church_time: "4:30 PM",
        itinerary_church_location: "Parroquia de la Sagrada Familia",
        itinerary_church_address: "Colonia Roma, CDMX",
        itinerary_cocktail_title: "RECEPCIÓN",
        itinerary_cocktail_time: "7:00 PM",
        itinerary_cocktail_location: "Casa del Corregidor",
        itinerary_cocktail_address: "Centro Histórico de la CDMX",
        itinerary_dining_title: "CENA Y BAILE",
        itinerary_dining_time: "8:00 PM",
        itinerary_dining_location: "Casa del Corregidor",
        itinerary_dining_address: "Centro Histórico de la CDMX",
        itinerary_googlemaps: "Abrir en Google Maps",
        // RSVP Log-in
        rsvp_login_title: "Acceso de Invitados",
        rsvp_login_code: "Código de Invitación:",
        rsvp_login_placeholder: "Ingresa tu código",
        rsvp_login_button: "Entrar",
        rsvp_login_wait: "Verificando...",
        // RSVP
        rsvp_title: "Confirma tu asistencia",
        rsvp_code_title: "Código recibido:",
        rsvp_name: "Nombre Completo:",
        rsvp_attending: "¿Asistirás a la boda?",
        rsvp_default: "Selecciona...",
        rsvp_yes: "Sí",
        rsvp_no: "No",
        rsvp_guests: "¿Cuántos asistirán (incluyéndote)?",
        rsvp_drinks: "¿Con qué bebida quieres celebrar?",
        rsvp_wine: "Vino",
        rsvp_rum: "Ron",
        rsvp_any_drink: "¡Con cualquiera!",
        rsvp_submit: "Enviar respuesta",
        rsvp_success: "¡Gracias por confirmar tu asistencia!",
        rsvp_confirmed_yes: "Te esperamos con mucha alegría.",
        rsvp_confirmed_no: "Es una pena que no podamos celebrar juntos, esperamos verte pronto.",
        rsvp_error: "Error al enviar la respuesta",
        // Gifts
        gift_title: "Mesa de Regalos",
        gift_card_title: "Palacio de Hierro",
        gift_card_header1: "Tu presencia es nuestro mayor regalo",
        gift_card_header2: "Sin embargo, agradecemos cualquier aportación para nuestra luna de miel",
        gift_card_button: "Ver Mesa de Regalos",
        gift_card_legend: "La carga de la página puede tardar un poco, Evento #404184",
        gift_store_title: "Mesa de Regalos",
        gift_store_subtitle: "Tu presencia es nuestro mayor regalo. Sin embargo, agradecemos cualquier aportación para nuestra nueva etapa",
        gift_category_label: "Categoría:",
        gift_category_all: "Todas",
        gift_category_electronics: "Electrónica",
        gift_category_appliances: "Electrodomésticos",
        gift_category_home: "Hogar",
        gift_category_honeymoon: "Luna de Miel",
        gift_sort_label: "Ordenar por:",
        gift_sort_none: "Recomendados",
        gift_sort_asc: "Precio: Menor a Mayor",
        gift_sort_desc: "Precio: Mayor a Menor",
        gift_sold_out: "Agotado",
        gift_buy_button: "Comprar Regalo",
        gift_processing: "Procesando...",
        gift_modal_title: "Información de la Compra",
        gift_modal_secure: "🔒 El pago será procesado de forma 100% segura a través de Stripe. No se almacenarán los datos de tu tarjeta.",
        gift_modal_name: "Nombre Completo",
        gift_modal_name_placeholder: "Ej. Juan Pérez",
        gift_modal_email: "Correo Electrónico",
        gift_modal_email_placeholder: "juan@ejemplo.com",
        gift_modal_cancel: "Cancelar",
        gift_modal_continue: "Continuar al Pago en Stripe",
    },
    en: {
        //Navbar
        navbar_home: "HOME",
        navbar_itinerary: "ITINERARY",
        navbar_confirm: "CONFIRM YOUR ATTENDANCE",
        navbar_gifts: "REGISTRY",
        // HeroSection
        hero_date: "August 29th 2026",
        hero_days: "DAYS",
        hero_hours: "HOURS",
        hero_minutes: "MINUTES",
        hero_seconds: "SECONDS",
        // Parents
        parents_title: "Accompanied by our parents, we invite you to our wedding",
        parents_gf: "Parents of the Bride",
        parents_bf: "Parents of the Groom",
        // Information
        information_title: "Please consider the following",
        information_weather_title: "WEATHER",
        information_weather: "Current weather in Mexico City",
        information_dresscode_title: "DRESS CODE",
        information_dresscode_type: "Formal",
        information_dresscode_colors: "No white colors",
        information_dresscode_men: "Men:",
        information_dresscode_men2: "Suite & tie",
        information_dresscode_women: "Women:",
        information_dresscode_women2: "Long evening dress",
        information_nokids_title: "NO KIDS",
        information_nokids_text: "Let's make this night a special date",
        information_nokids_text2: "Thank you for your understanding",
        // Recommendations
        recommendations_title: "Recommendations for your visit",
        card_hotel_title: "ACCOMMODATION",
        card_hotel_header1: "If you are visiting from out of town...",
        card_hotel_header2: "We have a discount at Hotel Barceló Reforma",
        btn_view_info: "View Information",
        btn_download_pdf: "Download PDF",
        card_transport_title: "TRANSPORTATION",
        card_transport_header1: "The venue has Valet Parking",
        card_transport_header2: "We recommend using Uber or Taxi for your comfort",
        pdf_fallback: "Your browser does not support PDFs.",
        pdf_download_link: "Download it here",
        // PhotoGallery
        photogallery_title: "Our Moments",
        photogallery_book: "Guest Book",
        photogallery_name: "Your name...",
        photogallery_message: "A memory or message you want to dedicate to us...",
        photogallery_send: "Send Message",
        // Footer
        footer_text: "Thank your for being with us in this special moment",

        // Itinerary
        itinerary_title: "Itinerary",
        itinerary_church_title: "CEREMONY",
        itinerary_church_time: "4:30 PM",
        itinerary_church_location: "Parroquia de la Sagrada Familia",
        itinerary_church_address: "Colonia Roma, Mexico City",
        itinerary_cocktail_title: "RECEPTION",
        itinerary_cocktail_time: "7:00 PM",
        itinerary_cocktail_location: "Casa del Corregidor",
        itinerary_cocktail_address: "Downtown Mexico City",
        itinerary_dining_title: "DINNER",
        itinerary_dining_time: "8:00 PM",
        itinerary_dining_location: "Casa del Corregidor",
        itinerary_dining_address: "Downtown Mexico City",
        itinerary_googlemaps: "Open in Google Maps",
        // RSVP Log-in
        rsvp_login_title: "Guest Log-in",
        rsvp_login_code: "Guest Code:",
        rsvp_login_placeholder: "Enter your code",
        rsvp_login_button: "Enter",
        rsvp_login_wait: "Verifying...",
        // RSVP
        rsvp_title: "Confirm your attendance",
        rsvp_code_title: "Code received:",
        rsvp_name: "Full Name:",
        rsvp_attending: "Will you attend the wedding?",
        rsvp_default: "Select...",
        rsvp_yes: "Yes",
        rsvp_no: "No",
        rsvp_guests: "How many will attend (including you)?",
        rsvp_drinks: "What drink do you want to celebrate with?",
        rsvp_wine: "Wine",
        rsvp_rum: " Rum",
        rsvp_any_drink: "With any!",
        rsvp_submit: "Send response",
        rsvp_success: "Thank you for confirming your attendance!",
        rsvp_confirmed_yes: "We look forward to seeing you.",
        rsvp_confirmed_no: "It's a shame we can't celebrate together, we hope to see you soon.",
        rsvp_error: "Error sending response",
        // Gifts
        gift_title: "Gift Registry",
        gift_card_title: "Palacio de Hierro",
        gift_card_header1: "Your presence is our greatest gift",
        gift_card_header2: "However, we would appreciate any contribution for our honeymoon",
        gift_card_button: "View Gift Registry",
        gift_card_legend: "The loading of the page might take a little while, Event #404184",
        gift_store_title: "Gift Registry",
        gift_store_subtitle: "Your presence is our greatest gift. However, we would appreciate any contribution for our honeymoon.",
        gift_category_label: "Category:",
        gift_category_all: "All",
        gift_category_electronics: "Electronics",
        gift_category_appliances: "Appliances",
        gift_category_home: "Home",
        gift_category_honeymoon: "Honeymoon",
        gift_sort_label: "Sort by:",
        gift_sort_none: "Recommended",
        gift_sort_asc: "Price: Low to High",
        gift_sort_desc: "Price: High to Low",
        gift_sold_out: "Sold Out",
        gift_buy_button: "Buy Gift",
        gift_processing: "Processing...",
        gift_modal_title: "Purchase Information",
        gift_modal_secure: "🔒 Payment will be processed 100% securely through Stripe. We do not store your card details.",
        gift_modal_name: "Full Name",
        gift_modal_name_placeholder: "e.g. John Doe",
        gift_modal_email: "Email Address",
        gift_modal_email_placeholder: "john@example.com",
        gift_modal_cancel: "Cancel",
        gift_modal_continue: "Continue to Secure Payment",
    },
    fr: {
        //Navbar
        navbar_home: "ACCUEIL",
        navbar_itinerary: "ITINERAIRES",
        navbar_confirm: "RSVP",
        navbar_gifts: "LISTE DE MARIAGE",
        // HeroSection
        hero_date: "29 août 2026",
        hero_days: "JOURS",
        hero_hours: "HEURES",
        hero_minutes: "MINUTES",
        hero_seconds: "SECONDES",
        // Parents
        parents_title: "Accompagnés par nos parents, nous vous invitons à notre mariage",
        parents_gf: "Parents de la mariée",
        parents_bf: "Parents du marié",
        // Information
        information_title: "Veuillez considérer ce qui suit",
        information_weather_title: "TEMPS",
        information_weather: "Temps actuel à Mexico",
        information_dresscode_title: "Code Vestimentaire",
        information_dresscode_type: "Formale",
        information_dresscode_colors: "Pas de couleurs claires",
        information_dresscode_men: "Hommes:",
        information_dresscode_men2: "Costume avec cravate",
        information_dresscode_women: "Femmes:",
        information_dresscode_women2: "Robe longue de soirée",
        information_nokids_title: "PAS D'ENFANTS",
        information_nokids_text: "Faisons de cette célébration une soirée spéciale",
        information_nokids_text2: "Merci de votre compréhension",
        // Recommendations
        recommendations_title: "Recommandations pour votre visite",
        card_hotel_title: "HÉBERGEMENT",
        card_hotel_header1: "Si vous venez de l'extérieur de la ville...",
        card_hotel_header2: "Nous avons une réduction à l'Hôtel Barceló Reforma",
        btn_view_info: "Voir les informations",
        btn_download_pdf: "Télécharger PDF",
        card_transport_title: "MOBILITÉ",
        card_transport_header1: "Le site dispose d'un service de voiturier",
        card_transport_header2: "Nous recommandons d'utiliser Uber ou un taxi pour plus de confort",
        pdf_fallback: "Votre navigateur ne prend pas en charge les PDF.",
        pdf_download_link: "Télécharger ici",
        // PhotoGallery
        photogallery_title: "Notre moments",
        photogallery_book: "Livret d'or",
        photogallery_name: "Votre nom...",
        photogallery_message: "Un souvenir ou un message que vous voulez nous envoyer...",
        photogallery_send: "Envoyer Message",
        // Footer
        footer_text: "Merci d'être avec nous dans ce moment si spécial",

        // Itinerary
        itinerary_title: "Itinéraires",
        itinerary_church_title: "CÉRÉMONIE",
        itinerary_church_time: "16:30",
        itinerary_church_location: "Paroisse de la Sainte Famille",
        itinerary_church_address: "Quartier Roma, Mexico",
        itinerary_cocktail_title: "COCKTAIL",
        itinerary_cocktail_time: "19:00",
        itinerary_cocktail_location: "Casa del Corregidor",
        itinerary_cocktail_address: "Centre-ville Mexico",
        itinerary_dining_title: "DÎNER",
        itinerary_dining_time: "20:00",
        itinerary_dining_location: "Casa del Corregidor",
        itinerary_dining_address: "Centre-ville Mexico",
        itinerary_googlemaps: "Ouvrir sur Google Maps",
        // RSVP Log-in
        rsvp_login_title: "Espace Invité",
        rsvp_login_code: "Code Invité:",
        rsvp_login_placeholder: "Saisissez votre code",
        rsvp_login_button: "Entrer",
        rsvp_login_wait: "Vérification...",
        // RSVP
        rsvp_title: "Confirmez votre présence",
        rsvp_code_title: "Code reçu:",
        rsvp_name: "Nom:",
        rsvp_attending: "Allez-vous assister au mariage ?",
        rsvp_default: "Sélectionnez...",
        rsvp_yes: "Oui",
        rsvp_no: "Non",
        rsvp_guests: "Combien de personnes viendront (y compris vous) ?",
        rsvp_drinks: "Avec quelle boisson voulez-vous célébrer ?",
        rsvp_wine: "Vin",
        rsvp_rum: "Rhum",
        rsvp_any_drink: "Avec n'importe laquelle !",
        rsvp_submit: "Envoyer réponse",
        rsvp_success: "Merci d'avoir confirmé votre présence !",
        rsvp_confirmed_yes: "Nous sommes impatients de vous voir.",
        rsvp_confirmed_no: "C'est dommage que nous ne puissions pas célébrer ensemble, nous espérons vous voir bientôt.",
        rsvp_error: "Erreur lors de l'envoi de la réponse",
        // Gifts
        gift_title: "Liste de Mariage",
        gift_card_title: "Palacio de Hierro",
        gift_card_header1: "Votre présence est notre plus beau cadeau",
        gift_card_header2: "Mais si vous souhaitez avoir un détail, votre contribution nous aiderait beaucoup avec notre lune de miel",
        gift_card_button: "Voir Liste de Mariage",
        gift_card_legend: "Le chargement de la page peut prendre un peu de temps, Événement #404184",
        gift_store_title: "Liste de Mariage",
        gift_store_subtitle: "Choisissez le cadeau parfait dans notre sélection",
        gift_category_label: "Catégorie :",
        gift_category_all: "Toutes",
        gift_category_electronics: "Électronique",
        gift_category_appliances: "Électroménager",
        gift_category_home: "Maison",
        gift_category_honeymoon: "Lune de Miel",
        gift_sort_label: "Trier par :",
        gift_sort_none: "Recommandés",
        gift_sort_asc: "Prix ​​: Croissant",
        gift_sort_desc: "Prix ​​: Décroissant",
        gift_sold_out: "Épuisé",
        gift_buy_button: "Acheter le cadeau",
        gift_processing: "En cours...",
        gift_modal_title: "Informations d'achat",
        gift_modal_secure: "🔒 Le paiement sera traité de manière 100% sécurisée via Stripe. Nous ne conservons pas les coordonnées de votre carte.",
        gift_modal_name: "Nom complet",
        gift_modal_name_placeholder: "Ex. Jean Dupont",
        gift_modal_email: "E-mail",
        gift_modal_email_placeholder: "jean@exemple.com",
        gift_modal_cancel: "Annuler",
        gift_modal_continue: "Passer au paiement sécurisé",
    }
};
